import { getPastUpdate, } from '@debbie/common/dist/workflows/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useWorkflowStagesMap } from '@debbie/cortex/dist/workflow-stages/index.js';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const WorkflowStages = (props) => {
    const { workflow, updates } = props;
    const currentUpdate = getPastUpdate(updates, workflow.workflowId);
    return (React.createElement(WorkflowStagesBar, { stages: workflow.stages, updates: updates, currentUpdate: currentUpdate }));
};
export default WorkflowStages;
// The plain stage bar, also usable without a case context (e.g. at the top
// of the workflow editor). Without updates no stage is marked active/current.
export const WorkflowStagesBar = (props) => {
    const { stages, updates, currentUpdate } = props;
    const workflowStagesMapLoadable = useWorkflowStagesMap();
    const workflowStagesMap = h.hasData(workflowStagesMapLoadable)
        ? workflowStagesMapLoadable.data
        : null;
    if (!stages || !workflowStagesMap) {
        return null;
    }
    return (React.createElement(Stages, null, stages.map((stage) => {
        const workflowStage = workflowStagesMap[stage.stageId];
        if (!workflowStage) {
            return null;
        }
        const active = !!updates?.find((update) => update.taskId && stage.taskIdMap[update.taskId]);
        const current = currentUpdate?.taskId != null &&
            !!stage.taskIdMap[currentUpdate.taskId];
        return (React.createElement(Stage, { current: current, active: active, "data-tooltip-content": workflowStage.label, "data-tooltip-id": "tooltip-default", key: workflowStage.id }, workflowStage.short ?? workflowStage.label));
    })));
};
const Stages = styled.div `
  display: inline-block;
  margin-left: 9px;
  font-size: 0.8em;
  font-weight: 600;
  vertical-align: middle;
`;
const Stage = styled.div `
  display: inline-block;
  position: relative;
  padding: 2px 4px;
  ${(props) => props.active
    ? `border: 1px solid ${THEME.COLOR_ACCENT}`
    : `border: 1px solid ${THEME.BORDER_STRONG}`};

  margin-left: -1px;

  &&:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  &&:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  ${(props) => (props.current ? 'padding-right: 11px;' : '')}
  ${(props) => props.current
    ? `
  &:after {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${THEME.COLOR_ACCENT};
    display: inline-block;
    position: absolute;
    top: 4px;
    right: 3px;
  }
  `
    : ''};
`;
//# sourceMappingURL=WorkflowStages.js.map